"use client";

import * as React from "react";
import styled from "styled-components";
const StyledBadgeList = styled.ul.withConfig({
  displayName: "BadgeList__StyledBadgeList",
  componentId: "sc-1r9trxb-0"
})(["margin:0;padding:0;display:flex;flex-direction:column;"]);
const BadgeList = ({
  children,
  dataTest,
  id
}) => {
  return /*#__PURE__*/React.createElement(StyledBadgeList, {
    "data-test": dataTest,
    id: id
  }, children);
};
export { default as BadgeListItem } from "./BadgeListItem";
export default BadgeList;